import { Vector2 } from 'three'
import GameObject from '../../../../e.elements/GameElements/classes/GameObject'
import { CHARACTER_ACTION } from '../constants'

export class CharacterAction {
  // 2d coords for game grid
  coords: Vector2
  // type of the action
  type?: CHARACTER_ACTION
  // if can be overwritten/discarded by other action
  mandatory?: boolean

  constructor(config?: Partial<CharacterAction> & { coords?: Vector2 }) {
    this.coords = config?.coords || new Vector2(0, 0)
    this.type = config?.type || CHARACTER_ACTION.AWAIT
    this.mandatory = config?.mandatory
  }
}

export class ActionAwait extends CharacterAction {
  constructor() {
    super()
    this.type = CHARACTER_ACTION.AWAIT
  }
}
export class ActionInvalid extends CharacterAction {
  constructor() {
    super({ mandatory: true })
    this.type = CHARACTER_ACTION.INVALID
  }
}
export class ActionMove extends CharacterAction {
  constructor(config: CharacterAction) {
    super(config)
    this.type = CHARACTER_ACTION.MOVE
  }
}
export class ActionDie extends CharacterAction {
  constructor() {
    super({ mandatory: true })
    this.type = CHARACTER_ACTION.DIE
  }
}

export type HitArgument = {
  dealer: GameObject
  power: number
}

export class ActionHitReceived extends CharacterAction {
  dealer: GameObject
  power: number
  constructor(config: HitArgument) {
    super({ mandatory: true })
    this.type = CHARACTER_ACTION.HIT_RECEIVED
    this.power = config.power
    this.dealer = config.dealer
  }
}
export class ActionGoTo extends CharacterAction {
  constructor(config: CharacterAction) {
    super(config)
    this.type = CHARACTER_ACTION.GOTO
  }
}
export class ActionAttackTo extends CharacterAction {
  targetUUID: string
  constructor({ uuid, ...args }: Partial<CharacterAction> & { uuid: string }) {
    super({ ...args, coords: new Vector2(0, 0) })
    this.targetUUID = uuid
    this.type = CHARACTER_ACTION.ATTACKTO
  }
}
export class ActionAttack extends CharacterAction {
  targetUUID: string
  // @todo weapon should be better here
  power: number
  constructor(uuid: string, power: number) {
    super()
    this.targetUUID = uuid
    this.power = power
    this.type = CHARACTER_ACTION.ATTACK
  }
}
export class ActionLoot extends CharacterAction {
  constructor(config?: Partial<CharacterAction>) {
    super(config)
    this.type = CHARACTER_ACTION.LOOT
  }
}
export class ActionRespawn extends CharacterAction {
  constructor() {
    super({ mandatory: true })
    this.type = CHARACTER_ACTION.RESPAWN
  }
}

// export default CharacterAction
